import { get } from 'lodash-es';
import { STATES } from '../../../constants';

const isSameMove = (move1, move2) => move1.id === move2.id;
// TODO: When there's no mover, the selectors give us back `{ id: undefined }`.
export const isSignedOut = mover => !mover.id;
export const isSignedIn = mover => !!mover.id;

export const menuItems = mover =>
  [
    {
      name: `I'm Moving`,
      useCtrl: true,
      show: isSignedOut(mover),
      method: 'goToSignIn',
    },
    {
      name: `Real Estate Pros`,
      uiSref: STATES.PRO_APP_SIGN_IN,
      show: isSignedOut(mover),
    },
    {
      name: mover.first_name,
      // Using `hidden-xx` because `visible-xs` forces display: block.
      classes: ['header-item mover-name hidden-sm hidden-md hidden-lg'],
      show: isSignedIn(mover),
    },
    {
      name: 'My Dashboard',
      uiSref: STATES.DASHBOARD,
      classes: ['chevron right'],
      show: isSignedIn(mover),
    },
    {
      name: 'My Account',
      uiSref: STATES.PROFILE,
      classes: ['chevron right'],
      show: isSignedIn(mover),
    },
    {
      name: 'Move Summary',
      uiSref: STATES.MOVES_SUMMARY,
      params: { moveId: get(mover, 'current_move.id', null) },
      classes: ['chevron right'],
      show: isSignedIn(mover),
    },
    {
      name: 'Switch to Another Move',
      classes: ['submenu'],
      options: mover.moves.map(move => ({
        id: `moveId${move.id}`, // Unique id for `ng-repeat`'s `track by`.
        name: `${move.from_address?.zip} → ${move.to_address.zip}`,
        uiSref: STATES.DASHBOARD,
        params: { moveId: move.id },
        classes:
          mover.current_move && isSameMove(move, mover.current_move)
            ? ['current-move']
            : [],
      })),
      show: mover.moves.length > 1,
    },
    {
      name: 'My Deals',
      uiSref: STATES.STEP_PROMOTIONS,
      classes: ['chevron right'],
      show: isSignedIn(mover),
    },
    {
      name: `I'm Moving Again`,
      uiSref: STATES.MOVES_NEW,
      classes: ['chevron right'],
      show: isSignedIn(mover),
    },
    {
      name: 'Sign Out',
      show: isSignedIn(mover),
      useCtrl: true,
      method: 'onSignOut',
    },
  ]
    // Unique id for `ng-repeat`'s `track by`.
    .map((item, index) => ({ ...item, id: index }));
